import { useNavigatePrompt } from 'utils/url/useNavigatePrompt';
export const NavigatePrompt = ({ when, message, }) => {
    useNavigatePrompt(when, message);
    return null;
};
